import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import keycode from 'keycode';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { fontSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { Props, OnRoleKeyDown, OnRoleClick } from './types';

const ManageRole = (props: Props) => {
	const { onRoleClick, text } = props;

	const onManageRoleClick: OnRoleClick = (evt) => {
		evt.stopPropagation();
		onRoleClick();
	};

	const onManageRoleKeyDown: OnRoleKeyDown = (evt) => {
		if (evt.keyCode && evt.keyCode === keycode('enter')) {
			onRoleClick();
		}
	};

	return (
		// @ts-expect-error - TS2322 - Type 'OnRoleKeyDown' is not assignable to type 'KeyboardEventHandler<HTMLDivElement> & OnRoleKeyDown'. | TS2322 - Type 'string' is not assignable to type 'never'.
		<ManageRoleWrapper onClick={onManageRoleClick} onKeyDown={onManageRoleKeyDown} tabIndex="0">
			{text}
		</ManageRoleWrapper>
	);
};

export default ManageRole;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ManageRoleWrapper = styled.div<{
	children?: ReactNode;
	onKeyDown: OnRoleKeyDown;
	onClick: OnRoleClick;
	tabIndex: string;
}>({
	cursor: 'pointer',
	padding: `${token('space.200', '16px')} ${token('space.300', '24px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderTop: `2px solid ${token('color.border.input', colors.N30)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N800),
});
ManageRoleWrapper.displayName = 'ManageRoleWrapper';
